module.exports = "/_next/static/images/facebook@3x-8f9a8a3950aa3ebd9002617507cc857c.png";